<template>

  <v-card>
    <v-toolbar dark color="primary">
      <v-row align-content="center">
        <v-col cols="10" align-self="center" class="text-left">
          <v-toolbar-title>
            {{ $t('Справочник Базис поставки') }}
          </v-toolbar-title>
        </v-col>
        <v-col v-if="canEdit" cols="2" align-self="center" class="text-right">
          <btn-icon-tip
              icon="add"
              icon-color="secondaryiconbtn"
              :tip="$t('Добавить запись в справочник')"
              @click="openAddDialog" />
        </v-col>
      </v-row>
    </v-toolbar>
    <!-- <general-error v-if="!!generalError && !isDialogOpened" /> -->
    <v-card-text>
      <v-row>
        <v-col>
          <validatable-incoterm-selection
              v-model="params.incotermId"
              :label="$t('Условия поставки')"
              only-with-basises
              :refresh="refresh" />
        </v-col>
        <v-col>
          <validatable-checkbox
              v-model="params.withHistory"
              :label="$t('Отобразить историю изменений')" />
        </v-col>
      </v-row>
      <paginated-data-table
          v-if="getDeliveryBasises"
          ref="paginatedTable"
          :headers="headers"
          :items="items"
          :loading="isLoading"
          item-key="deliveryBasisRevisionId"
          :items-per-page="itemsPerPage"
          :total-count="totalCount"
          :locale="systemLocale"
          :request-method="getDeliveryBasises">

        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.descriptionRu="{ item }">
          {{ item.descriptionRu }}
        </template>

        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.descriptionEn="{ item }">
          {{ item.descriptionEn }}
        </template>

        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.shippingCost="{ item }">
          {{ item.shippingCost }}
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.creatorUserName="{ item }">
          <route-link-with-tip
              v-if="item.creatorUserName"
              :id="item.creatorId"
              :text="item.creatorUserName"
              :tip="$t('Просмотр пользователя')"
              :to="{ path: `${urlRootPath}/user/${item.creatorId}` }" />
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.createdDate="{ item }">
          {{ item.createdDate
            ? $moment(item.createdDate).format('DD.MM.YYYY HH:mm')
            : null }}
        </template>

        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.deliveryBasisRevisionId="{ item }">
          <v-row class="text-left">
            <btn-icon-tip
                v-if="canEdit"
                icon="edit"
                :tip="$t('Редактировать')"
                @click="openEditDialog(item)" />
            <btn-icon-tip
                v-if="canDelete"
                icon="delete"
                :tip="$t('Удалить')"
                @click="openConfirmDialog(item)" />
          </v-row>
        </template>
      </paginated-data-table>
    </v-card-text>
    <delivery-basis-dialog
        v-if="deliveryBasisDialog.show"
        :dialog-prop="deliveryBasisDialog"
        @close="closeDialog('deliveryBasisDialog')" />
    <confirm-dialog
        v-if="confirmDialog.show"
        :dialog-prop="confirmDialog"
        @close="closeDialog('confirmDialog')" />
  </v-card>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  // import GeneralError from '@/components/reused/common/GeneralError.vue'
  import DeliveryBasisDialog from './DeliveryBasisDialog.vue'
  import ValidatableIncotermSelection from '@/components/reused/ui/ValidatableIncotermSelection.vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import { mapActions, mapState } from 'vuex'
  import { DELIVERY_BASISES_MANAGEMENT, DICTIONARIES } from '@/constants/store.js'
  import { DICTIONARY_TYPES } from '@/constants/business.js'

  export default {
    components: {
      BtnIconTip,
      // GeneralError,
      DeliveryBasisDialog,
      ValidatableIncotermSelection,
      ValidatableCheckbox,
      PaginatedDataTable,
      RouteLinkWithTip,
      ConfirmDialog
    },
    data () {
      return {
        isLoading: false,
        refresh: false,
        itemsPerPage: 10,
        deliveryBasisDialog: {
          show: false,
          item: null,
          callback: null
        },
        params: {
          incotermId: null,
          withHistory: false
        },
        confirmDialog: {
          text: null,
          additional: null,
          callback: null,
          warning: true,
          show: false
        }
      }
    },
    computed: {
      ...mapState(DELIVERY_BASISES_MANAGEMENT.NAMESPACE, {
        deliveryBasisesInfo: state => (state[DELIVERY_BASISES_MANAGEMENT.STATE.DELIVERY_BASISES] || {})
      }),
      items () {
        return this.deliveryBasisesInfo.items || []
      },
      totalCount () {
        return this.deliveryBasisesInfo.totalCount || 0
      },
      headers () {
        let headers = [
          { text: this.$t('Идентификатор записи справочника'), align: 'start', groupable: false, sortable: true, value: 'deliveryBasisId' },
          { text: this.$t('Описание (RU)'), align: 'start', groupable: false, sortable: true, value: 'descriptionRu' },
          { text: this.$t('Описание (EN)'), align: 'start', groupable: false, sortable: true, value: 'descriptionEn' },
          { text: this.$t('Расходы продавца по доставке покупателю'), align: 'start', groupable: false, sortable: true, value: 'shippingCost' },
          { text: this.$t('Изменения внесены'), align: 'start', groupable: false, sortable: false, value: 'creatorUserName' },
          { text: this.$t('Дата изменений'), align: 'start', groupable: false, sortable: true, value: 'createdDate' },
          { text: this.$t('Действия'), align: 'center', groupable: false, sortable: false, value: 'deliveryBasisRevisionId' }
        ]
        if (!this.params.withHistory) {
          headers = headers.filter(h => h.value !== 'creatorUserName' && h.value !== 'createdDate' && h.value !== 'deliveryBasisId')
        } else {
          headers = headers.filter(h => h.value !== 'deliveryBasisRevisionId')
        }
        return headers
      },
      isDialogOpened () {
        return this.deliveryBasisDialog.show
      },
      canEdit () {
        return (this.isAdmin || this.isOrganizer) &&
          this.params.incotermId &&
          !this.params.withHistory
      },
      canDelete () {
        return (this.isAdmin || this.isOrganizer) &&
          this.params.incotermId &&
          !this.params.withHistory
      }
    },
    watch: {
      'params.incotermId': {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            this.getValuesFromServer()
          }
        }
      },
      'params.withHistory': {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal !== oldVal && this.params.incotermId) {
            this.getValuesFromServer()
          }
        }
      }
    },
    created () {
      const vm = this
      vm.clearStore().then()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(DELIVERY_BASISES_MANAGEMENT.NAMESPACE, {
        getDeliveryBasisesAction: DELIVERY_BASISES_MANAGEMENT.ACTIONS.GET_DELIVERY_BASISES,
        addDeliveryBasisAction: DELIVERY_BASISES_MANAGEMENT.ACTIONS.ADD_DELIVERY_BASIS,
        editDeliveryBasisAction: DELIVERY_BASISES_MANAGEMENT.ACTIONS.EDIT_DELIVERY_BASIS,
        deleteDeliveryBasisAction: DELIVERY_BASISES_MANAGEMENT.ACTIONS.DELETE_DELIVERY_BASIS,
        clearDeliveryBasisesAction: DELIVERY_BASISES_MANAGEMENT.ACTIONS.CLEAR_DELIVERY_BASISES
      }),
      ...mapActions(DICTIONARIES.NAMESPACE, {
        clearDictionaryItemsAction: DICTIONARIES.ACTIONS.CLEAR_DICTIONARY_ITEMS
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.clearDeliveryBasisesAction(),
            this.clearDictionaryItemsAction(DICTIONARY_TYPES.INCOTERMS)
          ])
      },
      openAddDialog: function () {
        this.deliveryBasisDialog.callback = this.addDeliveryBasis
        this.deliveryBasisDialog.show = true
      },
      openEditDialog: function (item) {
        this.deliveryBasisDialog.item = item
        this.deliveryBasisDialog.callback = this.editDeliveryBasis
        this.deliveryBasisDialog.show = true
      },
      getValuesFromServer: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      refreshIncoterms: async function () {
        this.refresh = true
        await this.$nextTick()
        this.refresh = false
      },
      addDeliveryBasis: async function (deliveryBasis) {
        try {
          this.isLoading = true
          await this.addDeliveryBasisAction({
            incotermId: this.params.incotermId,
            deliveryBasis
          })
          this.isLoading = false
          this.edited()
          this.$refs.paginatedTable?.getDataFromServer()
        } finally {
          this.isLoading = false
        }
      },
      edited: function () {
        this.$emit('edited')
      },
      editDeliveryBasis: async function (deliveryBasis) {
        try {
          this.isLoading = true
          await this.editDeliveryBasisAction(deliveryBasis)
          this.isLoading = false
          this.$refs.paginatedTable?.getDataFromServer()
        } finally {
          this.isLoading = false
        }
      },
      getDeliveryBasises: async function (params) {
        try {
          this.isLoading = true
          await this.getDeliveryBasisesAction({
            ...params,
            ...this.params
          })
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      deleteВeliveryBasis: async function (model) {
        try {
          this.isLoading = true
          await this.deleteDeliveryBasisAction(model)
          this.edited()
          this.$refs.paginatedTable?.getDataFromServer()
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      openConfirmDialog: function (item) {
        this.confirmDialog.text = this.$t('Маршрут будет удален. Продолжить?')
        this.confirmDialog.additional = { incotermId: item.incotermId, deliveryBasisId: item.deliveryBasisId }
        this.confirmDialog.callback = this.deleteВeliveryBasis
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      }
    }
  }
</script>
